"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommissionSettlement = void 0;
class CommissionSettlement {
}
exports.CommissionSettlement = CommissionSettlement;
//# sourceMappingURL=CommissionSettlement.js.map